import React, {Component} from 'react';
import studiosLogo from './images/wnyc-studios.svg';
import momaLogo from './images/moma.svg';
import logo from './images/apow.png';
// import sponsor from './images/bloomberg.svg';
import apple from './images/buttons/apple-podcast.svg';
import google from './images/buttons/google-play.svg';
//import spotify from './images/buttons/spotify.svg';
import './vendor/font-awesome.min.css';
import './App.css';
import FontAwesome from 'react-fontawesome';
import fetchJsonp from 'fetch-jsonp';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      message: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    let url = 'https://nypublicradio.us5.list-manage.com/subscribe/post-json?u=4109fdd323aaac7078eadaa8f&id=29bf87e44a&EMAIL=' + this.state.value;

    fetchJsonp(url, {jsonpCallback: 'c'}).then(response => response.json().then(data => {
      this.setState({message: data.msg});
      var noEmail  = '0 - Please enter a value';
      var singleAt = '0 - An email address must contain a single @';
      var domainInvalid = '0 - The domain portion of the email address is invalid (the portion after the @: ab)';
      if (data.msg === noEmail) {
        this.setState({ message: 'Whoops! You need to enter your email.' })
      } else if (data.msg === singleAt) {
        this.setState({ message: 'Whoops! Your email address should only contain one @' })
      } else if (data.msg === domainInvalid) {
        this.setState({ message: 'Whoops! The domain portion of the email address is invalid (the portion after the @: ab)' })
      }
    }
    ));
    event.preventDefault();
  }

  render() {
    return (
      <div className="page">
        <div className="background">
        <div className="box">

          <div className="box__top">
            <div className="box__producer">
              <a href="http://wnycstudios.wnyc.org/" target="_blank">
                <img src={studiosLogo} alt="WNYC Studios logo"
                     className="clicked__pieceofwork__wnycstudios-header btn__spacer--bigger" />
              </a>
              <a href="https://www.moma.org/" target="_blank" className="moma__logo--anchor">
               <img src={momaLogo} alt="MoMA logo" className="btn__spacer--bigger moma__logo"/>
              </a>
            </div>

            <div className="box__header">
              <div className="box__logo">
                <img src={logo} alt="MoMA logo"/>
              </div>
              <div className="box__title">
                <h2>A Piece of Work</h2>
                <h3>Hosted by Broad City's Abbi Jacobson</h3>
              </div>
            </div>

            <div className="box__description">
              <i>A Piece of Work</i> is everything you wanted to know about modern and contemporary art but were afraid to ask. A bicycle wheel attached to a stool; a giant canvas splattered with paint; dozens of soup cans...for many museum visitors, works like these prompt a ton of questions. In this 10-episode podcast series, Abbi looks for some answers in lively conversations with curators, artists, and some friends, including Hannibal Buress, Tavi Gevinson, RuPaul, and Questlove.
            </div>

            
            <div className="box__buttons">
              <a href="https://itunes.apple.com/us/podcast/id1256553977" target="_blank"
                 title="Listen to the podcast on Apple Podcast">
                <img src={apple} alt="Listen to the podcast on Apple Podcast"
                 className="clicked__pieceofwork__apple-podcast btn__spacer" />
              </a>
              <a href="https://play.google.com/music/listen?u=0#/ps/Ilejnqrkhgflyrfjnybted6hgcy" target="_blank"
                 title="Listen to the podcast on Google Play">
                <img src={google} alt="Listen to the podcast on Google Play"
                 className="clicked__pieceofwork__google-play btn__spacer" />
              </a>

            </div>
            

          </div>

          <div className="box__bottom">

            <div className="box__newsletter">
              <h3 className="text--large text--white">
                Stay Connected to Us
              </h3>

              <div className="mailchimp-form">
                <form onSubmit={this.handleSubmit}>
                  <label>
                    <input placeholder="Enter your email" type="email" value={this.state.value} onChange={this.handleChange}/>
                  </label>
                  <input type="submit" value="Sign up" className="clicked__pieceofwork__newsletter" />
                </form>
                <div className="box__newsletter--error clicked__pieceofwork__update-newsletter-profile" dangerouslySetInnerHTML={{ __html: this.state.message }}/></div>
              </div>

              <div className="box__footer">
                <a href="https://www.facebook.com/WNYCStudios/" target="_blank"
                   className="link--white clicked__pieceofwork__facebook-page">
                  <FontAwesome name='facebook'/>
                  Facebook
                </a>
                <a href="https://twitter.com/wnycstudios" target="_blank"
                   className="link--white clicked__pieceofwork__twitter-page">
                  <FontAwesome name='twitter'/>
                  Twitter
                </a>
              </div>
            </div>
          </div>

        </div>

        <div className="inner text--gray">

          {/* 
            <div className="sponsor">
            <p>This podcast is made possible through Bloomberg Philanthropies's support of The Museum of Modern Art</p>
            <a href="https://www.bloomberg.org/" target="_blank">
              <img src={sponsor} alt="Bloomberg Philanthropies"/>
            </a>
            </div>
          */}
          <div>&copy; 2017 <a href="http://wnycstudios.wnyc.org/" target="_blank" className="clicked__pieceofwork__wnycstudios-footer">WNYC Studios</a>.</div>
        </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js